module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx_about"
  }, [_c('div', {
    staticClass: "about"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo.png")
    }
  })]), _vm._v(" "), _c('h6', [_vm._v("发 票 夹 做 您 贴 心 的 发 票 小 助 手")]), _vm._v(" "), _c('p', {
    staticClass: "xian"
  }), _vm._v(" "), _c('p', [_vm._v("电话：400-655-5019")]), _vm._v(" "), _c('p', [_vm._v("邮箱：service@vpiaotong.com ")])]), _vm._v(" "), _c('div', {
    staticClass: "queding"
  }, [_c('p', [_vm._v("京ICP备16025903号 ")]), _vm._v(" "), _c('p', [_vm._v("北京票通信息技术有限公司版权所有 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62d21a01"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/about.vue
// module id = 338
// module chunks = 0